import { createRouter, createWebHistory } from "vue-router";

import Home from "../views/Home.vue";
import Proyectos from "../views/Proyectos.vue";
import Habilidades from "../views/Habilidades.vue";
import Demos from "../views/Demos.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/proyectos",
    name: "Proyectos",
    component: Proyectos,
  },
  {
    path: "/habilidades",
    name: "Habilidades",
    component: Habilidades,
  },
  {
    path: "/demos",
    name: "Demos",
    component: Demos,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
